import { useEffect } from 'react';
import {
  useGetAllUnSettledOrdersQuery,
  useGetRestaurantSettledOrdersQuery,
  useGetSettledOrdersQuery,
} from 'src/utils/__generated__/graphql';
import { useGetRestaurantUnSettledOrdersQuery } from '../utils/__generated__/graphql';

export const useSettlementData = (startDate?: string, endDate?: string, restaurantId?: string) => {
  const {
    data: unsettledData,
    loading: unsettledLoading,
    error: unsettledError,
    refetch: refetchUnsettled,
  } = restaurantId
    ? useGetRestaurantUnSettledOrdersQuery({
        variables: {
          restaurantId,
        },
      })
    : useGetAllUnSettledOrdersQuery();
  const {
    data: settledData,
    loading: settledLoading,
    error: settledError,
    refetch: refetchSettled,
  } = restaurantId
    ? useGetRestaurantSettledOrdersQuery({
        variables: { startDate, endDate, restaurantId },
      })
    : useGetSettledOrdersQuery({
        variables: { startDate, endDate },
      });

  useEffect(() => {
    refetchUnsettled();
    refetchSettled();
  }, [refetchUnsettled, refetchSettled]);

  return {
    unsettledData,
    settledData,
    loading: unsettledLoading || settledLoading,
    unsettledError,
    settledError,
  };
};
